export default "__VITE_ASSET__Ccgd59eZ__"